// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.oncUmDlSQaKJ9otdENfQ {
    all: unset;
    line-height: 0;
    cursor: pointer
}

.C_dRlCfuvsK41mMmkBnT:hover .oncUmDlSQaKJ9otdENfQ .cMYgXhwamqNTsDfyT3ns,
.oncUmDlSQaKJ9otdENfQ:hover:not(.C_dRlCfuvsK41mMmkBnT .oncUmDlSQaKJ9otdENfQ:hover) .cMYgXhwamqNTsDfyT3ns {
    filter: drop-shadow(var(--map-popup-box-shadow));
}

.rAn698BpfQ4FhLzC0mtf {
    color: var(--default-icon-color);
}

.fkwAuStc0SLT___9JXi1 {
    color: var(--light-icon-color);
}

.p_FzOEKM700_ZlZyzK7J {
    color: var(--dark-icon-color);
}

.yKLORqQ2N5hh9IbHzDtA,
.dvtaSv1S2H4WKMFn6tjA,
.YBx7lL2a4wUn2hRcuVmR {
    color: var(--default-icon-color);
}

.yKLORqQ2N5hh9IbHzDtA :where(path, rect),
.dvtaSv1S2H4WKMFn6tjA :where(path, rect) {
    stroke: currentColor !important;
}

.yKLORqQ2N5hh9IbHzDtA :where(path, circle),
.dvtaSv1S2H4WKMFn6tjA :where(path, circle) {
    fill: currentColor !important;
}

.oncUmDlSQaKJ9otdENfQ[data-active="true"] .yKLORqQ2N5hh9IbHzDtA {
    color: var(--active-icon-color);
}

.YBx7lL2a4wUn2hRcuVmR :where(path, rect, circle) {
    stroke: currentColor !important;
}

.YBx7lL2a4wUn2hRcuVmR :where(path) {
    fill: currentColor !important;
}`, "",{"version":3,"sources":["webpack://./../core/components/buttons/IconButton.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd;AACJ;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["button.iconButton {\r\n    all: unset;\r\n    line-height: 0;\r\n    cursor: pointer\r\n}\r\n\r\n.iconTextContainer:hover .iconButton .iconSvg,\r\n.iconButton:hover:not(.iconTextContainer .iconButton:hover) .iconSvg {\r\n    filter: drop-shadow(var(--map-popup-box-shadow));\r\n}\r\n\r\n.iconColorDefault {\r\n    color: var(--default-icon-color);\r\n}\r\n\r\n.iconColorLight {\r\n    color: var(--light-icon-color);\r\n}\r\n\r\n.iconColorDark {\r\n    color: var(--dark-icon-color);\r\n}\r\n\r\n.trackIconSvg,\r\n.locButtonSvg,\r\n.tipIconSvg {\r\n    color: var(--default-icon-color);\r\n}\r\n\r\n.trackIconSvg :where(path, rect),\r\n.locButtonSvg :where(path, rect) {\r\n    stroke: currentColor !important;\r\n}\r\n\r\n.trackIconSvg :where(path, circle),\r\n.locButtonSvg :where(path, circle) {\r\n    fill: currentColor !important;\r\n}\r\n\r\n.iconButton[data-active=\"true\"] .trackIconSvg {\r\n    color: var(--active-icon-color);\r\n}\r\n\r\n.tipIconSvg :where(path, rect, circle) {\r\n    stroke: currentColor !important;\r\n}\r\n\r\n.tipIconSvg :where(path) {\r\n    fill: currentColor !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconButton": `oncUmDlSQaKJ9otdENfQ`,
	"iconTextContainer": `C_dRlCfuvsK41mMmkBnT`,
	"iconSvg": `cMYgXhwamqNTsDfyT3ns`,
	"iconColorDefault": `rAn698BpfQ4FhLzC0mtf`,
	"iconColorLight": `fkwAuStc0SLT___9JXi1`,
	"iconColorDark": `p_FzOEKM700_ZlZyzK7J`,
	"trackIconSvg": `yKLORqQ2N5hh9IbHzDtA`,
	"locButtonSvg": `dvtaSv1S2H4WKMFn6tjA`,
	"tipIconSvg": `YBx7lL2a4wUn2hRcuVmR`
};
module.exports = ___CSS_LOADER_EXPORT___;
